import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { MealRestrictionsWidget } from '@/widgets/meal-restrictions-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.searchQuery': z.string().optional(),
  'filter.grades': z.array(z.string()).optional(),
  'filter.schoolId': z.string().optional(),
  'filter.activeOn': z.string().optional(),
})

export const Route = createFileRoute('/_auth/canteen/meal-restrictions/')({
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper title={t('Список ограничений в питании учеников')}>
      <MealRestrictionsWidget />
    </PageWrapper>
  )
}
